export module SettingConstants {
    export const SECRET_KEY: string = "HIVE-SECURE-KEY"
}
